import React from 'react'
import type { ReactNode } from 'react'

import Icon from 'components/Icon'
import styles from './SpRowButton.module.css'

// WHY: Reception/SpRowButton とほぼ同一だが、レガシー側は styled-components 実装のため
// src/components/ への共通化は別 PR で対応する（現状は複製を許容）
// WHY: アイコンは lucide-react ではなくレガシー SP(Reception 側)と意匠を揃えるため既存 Icon(img) を使う
type Props = {
  children: ReactNode
  onClick: () => void
}

export const SpRowButton = ({ children, onClick }: Props) => (
  <button type="button" className={styles.button} onClick={onClick}>
    <div className={styles.content}>{children}</div>
    <Icon
      src="/assets/svgs/arrow-right-blue.svg"
      width="12px"
      height="12px"
      className={styles.arrow}
    />
  </button>
)
